import { render, staticRenderFns } from "./docente-visitas.vue?vue&type=template&id=0b517800"
import script from "./docente-visitas.vue?vue&type=script&lang=js"
export * from "./docente-visitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports